import _ from 'lodash'
import React, { useEffect, useRef, useState } from 'react'

import { Attachment, Button } from '../index'

import './index.scss'

/**
 * @param {String} label - the label
 * @param {Boolean} required - flag indicating required
 * @param {Object} value - e.g. `{ name: "Sample", size: 3000 }`
 * @param {String} accept - files accepted in input
 * @param {Boolean} error - flag indicating error
 * @param {Boolean} disabled - flag indicating disabled
 * @param {Boolean} hasFileSize - indicates if the file has size value
 * @param {Boolean} fromFieldArray - indicates if components is in FieldArray
 * @param {Boolean} removeFile - indicates if any files were removed by FieldArray
 * @param {Function} onChange - callback for onChange, who receives the input value in the first parameter and a boolean in the second that defines if the operation is a removal (needed only when the InputFile is inside in FieldArray)
 * @param {Function} onInvalid - callback for onInvalid
 * @param {Function} removeFileFromFieldArray - call function to remove file from FieldArray
 * @param {Function} changeRemoveFile - call function to change value of 'removeFile' attibute
 *
 * @returns {React.ReactElement}
 */
const InputFile = ({ label = "Sample", required = false, value, accept = ".zip, .rar, .doc, .docx, .pdf, .xls, .xlsx, .xlsm, .xltm, xlam, .xlsb, .xltx, .csv, .ods, image/*", error, disabled, hasFileSize, fromFieldArray = false, removeFile = false, onChange = (value, isRemove) => { }, onInvalid = () => { }, removeFileFromFieldArray = () => { }, changeRemoveFile = () => { } }) => {
  const inputFileRef = useRef(null)
  const [file, setFile] = useState(false)
  const [hasError, setHasError] = useState(error)

  useEffect(() => {
    if (_.isEmpty(value)) {
      setFile(false)
    } else {
      setFile(value)
    }
  }, [value])

  useEffect(() => {
    if (removeFile) {
      const onRemoveFile = function () { handleRemoveFile(true) }
      onRemoveFile()
    }
  }, [removeFile])

  useEffect(() => setHasError(error), [error])

  function handleOnClickChooseFile(evt) {
    evt.preventDefault()
    inputFileRef.current.click()
  }

  function validateAcceptFile(file) {
    const acceptExtension = accept.replace(/[\s\*\.\/]/g, '').split(',').map(e => `(${e})`).join('|')
    const regex = new RegExp(acceptExtension, 'g')
    return file && regex.test(file.type)
  }

  function handleOnChangeFile(evt) {
    const file = evt.target.files[0]
    const fileExtension = file.name.split('.').pop()
    const fileName = file.name.replace(`.${fileExtension}`, '').replace(/[^a-zA-Z0-9_-]/g, '')
    const formattedName = `${fileName}.${fileExtension}`

    if(!validateAcceptFile(file)) {
      alert('Documento inválido')
      inputFileRef.current.value = null
      return
    }

    if (fileName.length < 5) {
      alert('O nome do arquivo precisa ter no mínimo 5 caracteres')
      inputFileRef.current.value = null
      return
    }

    const blob = file.slice(0, file.size, file.type);
    const newFile = new File([blob], formattedName, { type: file.type });

    setFile(newFile)
    onChange && onChange({ name: formattedName, size: newFile.size, file: newFile }, false)
  }

  function handleRemoveFile(removeItemFromFieldArray) {
    setFile(null)
    inputFileRef.current.value = null
    if (fromFieldArray) {
      if (removeItemFromFieldArray) {
        removeFileFromFieldArray()
      } else {
        onChange({}, true)
      }
    } else {
      onChange({}, true)
    }

    if (removeItemFromFieldArray) {
      changeRemoveFile()
    }
  }

  function handleOnInvalid() {
    setHasError(true)
    onInvalid && onInvalid()
  }

  function returnClassName() {
    let currentClassName = "input-file__wrapper"
    if (hasError) currentClassName += " input-file__wrapper--error"
    if (disabled) currentClassName += " input-file__wrapper--disabled"
    return currentClassName
  }

  return (
    <div className={returnClassName()} title={`${label}${required ? " *" : ""}`}>
      <span className="input-file__label" >{label}{required && " *"}</span>
      <div className="input-file">
        <input ref={inputFileRef} name={label} type="file" onChange={handleOnChangeFile} accept={accept} multiple={false} required={value ? false : required} onInvalid={handleOnInvalid} />
        {!file && <Button onClick={handleOnClickChooseFile} icon="Paperclip" size="small" fullWidth>Adicionar {label}</Button>}
        {file && (
          <Attachment
            fileName={file.name}
            fileSize={hasFileSize && file.size}
            removeAction={handleRemoveFile}
          />
        )}
      </div>
    </div>
  )
}

export default InputFile
